import {
    ApiBaseService,
    type EnhancedFetch,
    type EnhancedFetchOptions,
} from "./ApiBaseService";

export type LiveStatMenuCounters = {};

export type LiveStats = {
    "menu-counters": LiveStatMenuCounters;
};

export const LiveStatsDefaults: LiveStats = {
    "menu-counters": {
        automations_count: 0,
        events_count: 0,
        runs_count: 0,
        tasks_count: 0,
    },
};

export default class LiveStatService extends ApiBaseService {
    public subscribe(
        key: keyof LiveStats,
        options?: Partial<EnhancedFetchOptions>,
    ): EnhancedFetch<LiveStats> {
        return this.enhancedFetch<LiveStats>(
            this.route("api.live-stats", "/live-stats/{stat}", {
                stat: key,
            }),
            options,
        );
    }
}
